import React, { useEffect, useState } from 'react';
import api from '../api';

function AdminWithdrawals() {
  const [requests, setRequests] = useState([]);
  const [networkFee, setNetworkFee] = useState({});
  const [adminMsg, setAdminMsg] = useState({});
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    api.get('/api/admin/withdrawals').then(res => setRequests(res.data));
  }, []);

  const handleReview = async (id, newStatus) => {
    const fee = networkFee[id] || 0;
    const msg = adminMsg[id] || '';
    try {
      await api.patch(`/api/admin/withdrawals/${id}`, {
        status: newStatus,
        networkFee: parseFloat(fee),
        adminMessage: msg,
      });
      // refresh
      const res = await api.get('/api/admin/withdrawals');
      setRequests(res.data);
      // clear fields
      setNetworkFee(prev => ({ ...prev, [id]: '' }));
      setAdminMsg(prev => ({ ...prev, [id]: '' }));
    } catch (err) {
      alert(err.response?.data?.error || 'Update failed');
    }
  };

  return (
    <div>
      <h2>Withdrawal Requests</h2>
      {requests.length === 0 ? <p>No pending requests.</p> : (
        <div className="table-box">
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Wallet</th>
                <th>Currency</th>
                <th>Amount</th>
                <th>To</th>
                <th>Status</th>
                <th>Network Fee</th>
                <th>Message</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.map(req => (
                <tr key={req.id}>
                  <td>{req.User?.email}</td>
                  <td>{req.User?.walletAddress?.slice(0,8)}...</td>
                  <td>{req.currency}</td>
                  <td>{req.amount}</td>
                  <td>{req.recipientAddress?.slice(0,8)}...</td>
                  <td style={{ color: req.status === 'approved' ? 'green' : req.status === 'rejected' ? 'red' : 'orange' }}>
                    {req.status}
                  </td>
                  <td>
                    {req.status === 'pending' && (
                      <input
                        type="number"
                        placeholder="Fee"
                        value={networkFee[req.id] || ''}
                        onChange={e => setNetworkFee(prev => ({ ...prev, [req.id]: e.target.value }))}
                        style={{ width: '80px', padding: '0.25rem' }}
                      />
                    )}
                    {req.status !== 'pending' && (req.networkFee ?? '—')}
                  </td>
                  <td>
                    {req.status === 'pending' && (
                      <input
                        placeholder="Reason (for rejection)"
                        value={adminMsg[req.id] || ''}
                        onChange={e => setAdminMsg(prev => ({ ...prev, [req.id]: e.target.value }))}
                        style={{ width: '120px', padding: '0.25rem' }}
                      />
                    )}
                    {req.status !== 'pending' && (req.adminMessage || '—')}
                  </td>
                  <td>
                    {req.status === 'pending' && (
                      <>
                        <button onClick={() => handleReview(req.id, 'approved')} style={{ background: '#10b981', color: 'white', border: 'none', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', marginRight: '0.25rem', cursor: 'pointer' }}>
                          Approve
                        </button>
                        <button onClick={() => handleReview(req.id, 'rejected')} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', cursor: 'pointer' }}>
                          Reject
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
export default AdminWithdrawals;